import { Box, Radio, TextField, IconButton } from "@mui/material";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";

type props = {
  name?: string;
  index?: number;
  selectedValue: string;
  phones?: any[];
  onRadioChange?: any;
  onDelete?: any;
  altPhone?: string;
  onPhoneChange?: any;
  isPhoneEmptyError?: boolean;
  phoneErrorText?: string;
};

export default function AlternativePhoneField({
  name,
  index,
  selectedValue,
  phones,
  onRadioChange,
  onDelete,
  altPhone,
  onPhoneChange,
  isPhoneEmptyError,
  phoneErrorText,
}: props) {
  return (
    <Box sx={{ display: "flex", alignItems: "center", mt: 2 }}>
      <Radio
        id={`alt-phone${index}`}
        sx={{ mr: 2 }}
        checked={selectedValue === `altPhone${index}`}
        onChange={onRadioChange}
        value={`altPhone${index}`}
        name="radio-buttons"
        inputProps={{ "aria-label": `Alternate Phone ${index}` }}
      />
      <TextField
        id="alt-phone"
        sx={{ width: "100%" }}
        label="Phone"
        variant="outlined"
        name={name}
        value={altPhone}
        onChange={onPhoneChange}
        error={!!phoneErrorText}
        helperText={phoneErrorText || ""}
        slotProps={{ htmlInput: { maxLength: 50 } }}
      />
      {selectedValue !== `altPhone${index}` ? (
        <IconButton aria-label="delete" onClick={onDelete}>
          <DeleteOutlineOutlinedIcon style={{ color: "#D32F2F" }} />
        </IconButton>
      ) : (
        <Box sx={{ width: 46 }}></Box>
      )}
    </Box>
  );
}
